import styles from "./MobileApp.module.scss";
import Heading from "../Typography/Heading/Heading";
import Text from "../Typography/Text/Text";
import QR from "../../static/images/QR_mobApp.png";
import googlePlay from "../../static/images/googlePlay.svg";
import appStore from "../../static/images/appStore.svg";
import phone from "../../static/images/phone.png";

export default function MobileApp() {
  return (
    <div id="MobileApp" className={styles.mobileApp}>
      <div className={styles.content}>
        <div className={styles.title}>
          <Heading level="h3" fw={700}>
            Скачивайте мобильное <br /> приложение Electrifly
          </Heading>
        </div>
        <div className={styles.description}>
          <div className={styles.qr}>
            <img src={QR} alt="" />
          </div>

          <Text size="base">
            Наведите камеру на QR-код для <br /> загрузки приложения
          </Text>
        </div>
        <div className={styles.apps}>
          <div className={styles.apps__item}>
            <a href="https://play.google.com/store/apps/details?id=ru.electrifly.facade">
              <img src={googlePlay} alt="" />
            </a>
          </div>
          <div className={styles.apps__item}>
            <a href="https://apps.apple.com/app/electrifly-charging-station/id1530713764">
              <img src={appStore} alt="" />
            </a>
          </div>
        </div>
        <div className={styles.phone}>
          <img src={phone} alt="" />
        </div>
      </div>
      <div className={styles.devider} />
    </div>
  );
}
